(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Widest viewport that still gets a sticky header when the "Always, on mobile
  // only" type is selected. Keep in step with the option label in the schema.
  const STICKY_HEADER_MOBILE_MAX_WIDTH = 1024;

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.stickyType = this.getAttribute('data-sticky-type');
      this.headerIsAlwaysSticky = ['always', 'always-mobile', 'reduce-logo-size'].includes(this.stickyType);

      // 'always-mobile' is the only type that stops sticking above the breakpoint.
      // Every other type sticks at all widths, which is what 'always' now means.
      this.stickyIsMobileOnly = this.stickyType === 'always-mobile';

      // Types that come to rest with the logo row above the viewport instead of
      // at top:0, leaving only the menu / search / account+cart strip on screen.
      this.stickyHidesLogoRow = ['always', 'on-scroll-up'].includes(this.stickyType);
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Feeds the CSS above the height of the logo row. Remeasure on resize
      // because the row grows when the menu or logo wraps.
      if (this.stickyHidesLogoRow) {
        this.setStickyOffset();
        this.stickyOffsetHandler = () => window.requestAnimationFrame(this.setStickyOffset.bind(this));
        window.addEventListener('resize', this.stickyOffsetHandler);
      }

      if (this.stickyIsMobileOnly) {
        this.stickyMediaQuery = window.matchMedia(`(max-width: ${STICKY_HEADER_MOBILE_MAX_WIDTH}px)`);
        this.handleStickyMediaChange = this.handleStickyMediaChange.bind(this);
        this.stickyMediaQuery.addEventListener('change', this.handleStickyMediaChange);
      }

      if (this.headerIsAlwaysSticky && this.isStickyEnabled()) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      if (this.isStickyEnabled()) {
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    /*
     * How much of the header scrolls away before the menu / search / account
     * strip comes to rest at the top of the viewport.
     *
     * That is the distance down to the second row, less the wrapper's own
     * bottom padding: stopping short by exactly that much leaves the strip with
     * matching bands of background above and below instead of the search field
     * sitting flush against the top of the window. Read from the computed style
     * so it follows .header-wrapper's padding rather than restating it here.
     *
     * The row positions come from viewport-relative rects, whose difference
     * holds regardless of how far the page has scrolled or whether the header
     * is currently stuck.
     */
    setStickyOffset() {
      const rows = [this.querySelector('.header__inline-menu'), this.querySelector('.header__icons')]
        .filter(Boolean)
        .map((element) => element.getBoundingClientRect().top);

      if (!rows.length) return;

      const distanceToRow = Math.min(...rows) - this.getBoundingClientRect().top;
      const breathingRoom = parseFloat(window.getComputedStyle(this).paddingBottom) || 0;

      const offset = Math.max(0, Math.round(distanceToRow - breathingRoom));
      document.documentElement.style.setProperty('--header-sticky-offset', `${offset}px`);
    }

    isStickyEnabled() {
      if (!this.stickyIsMobileOnly) return true;
      return window.innerWidth <= STICKY_HEADER_MOBILE_MAX_WIDTH;
    }

    handleStickyMediaChange(e) {
      if (e.matches) {
        // Back under the breakpoint, enable sticky
        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        }
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      } else {
        // Above the breakpoint, disable sticky
        this.reset();
        this.header.classList.remove('scrolled-past-header', 'shopify-section-header-sticky', 'shopify-section-header-hidden', 'animate');
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.stickyOffsetHandler) {
        window.removeEventListener('resize', this.stickyOffsetHandler);
      }
      if (this.stickyMediaQuery) {
        this.stickyMediaQuery.removeEventListener('change', this.handleStickyMediaChange);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Bail out on desktop when the sticky type is limited to mobile.
      if (!this.isStickyEnabled()) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (!this.isStickyEnabled() || this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (!this.isStickyEnabled() || this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (!this.isStickyEnabled() || this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
